
import get from 'lodash/get'

export const getVideoAspect = (video) => {
  const aspect = get(video, ['data', 'aspect_ratio'], '16:9').split(':')
  return aspect[1] / aspect[0]
}
